import { Alert, Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';

const ManagedByThirdPartyAlert = ({ showThirdPartyEmailModal, name }) => {
  return (
    <Alert
      banner
      type="success"
      title={name ? `Managed by ${name}` : 'Managed by a third party'}
      closeable
      style={{
        marginBottom: 'var(--spacing-md)',
        width: '30%',
      }}
      action={
        <Button size="small" type="link" onClick={showThirdPartyEmailModal}>
          <EditOutlined />
        </Button>
      }
    />
  );
};

export default ManagedByThirdPartyAlert;
